// Source: https://github.com/pladaria/requestidlecallback-polyfill/blob/master/index.js
// Polyfill is required for Safari and IE.
// Local exports so we can just use this function as a util and the polyfill is
// automatically loaded and uninstalled if this function stops being used.

interface RequestIdleCallback {
  didTimeout?: boolean
  timeRemaining?(): DOMHighResTimeStamp
}

interface RequestIdleCallbackOptions {
  timeout?: number
}

type RequestIdleCallbackId = number
type Callback = (deadline: RequestIdleCallback) => unknown

declare global {
  interface Window {
    requestIdleCallback(
      cb: Callback,
      options?: RequestIdleCallbackOptions,
    ): RequestIdleCallbackId
    cancelIdleCallback(id: RequestIdleCallbackId): void
  }
}

export default function requestIdleCallback(cb: Callback) {
  const start = Date.now()
  // It's safe to convert NodeJS.setTimeout to a Number.
  return Number(
    setTimeout(function () {
      cb({
        didTimeout: false,
        timeRemaining: function () {
          return Math.max(0, 50 - (Date.now() - start))
        },
      })
    }, 1),
  )
}

export function cancelIdleCallback(id: RequestIdleCallbackId) {
  clearTimeout(id)
}

function polyfillRequestIdleCallback() {
  if (typeof window === 'undefined') {
    return
  }
  window.requestIdleCallback = window.requestIdleCallback || requestIdleCallback
}

function polyfillCancelIdleCallback() {
  if (typeof window === 'undefined') {
    return
  }
  window.cancelIdleCallback = window.cancelIdleCallback || cancelIdleCallback
}

polyfillRequestIdleCallback()
polyfillCancelIdleCallback()
